export { ScrollMinimap } from './ui/ScrollMinimap';
export type { ScrollMinimapProps, MinimapColumn } from './ui/ScrollMinimap';
